import i18n from "i18next";
import type { FC } from "react";
import { useDispatch } from "react-redux";

import { useCampaignMutation } from "src/app/features/Campaign/services/server/CampaignApi";
import type { CampaignEntity } from "src/app/features/Campaign/types/CampaignEntity";
import { ButtonEvents } from "../../../../../components/Buttons/ButtonEvents";
import { GenericConfirmationSecondaryButton } from "../../../../../components/Buttons/components/GenericConfirmationSecondaryButton";
import type { ButtonProps } from "../../../../../components/FeatureButtons/types";
import { showSuccessNotification } from "../../../../../components/NotificationAlerts";
import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";

export const StopButton: FC<ButtonProps<CampaignEntity>> = ({ isDisabled, item, items, onReload }) => {
    const dispatch = useDispatch();
    const [request] = useCampaignMutation();

    const callBackend = () => {
        const notifyOk = () => {
            dispatch(
                showSuccessNotification({
                    text: i18n.t("success.campaign.stop.successfully", {
                        0: item?.id,
                    }),
                    autoCloseDisabled: false,
                }),
            );
        };

        const groupCode = getAssignedDataGroup()?.code;
        const baseURI = `${ResourceName.DATA_GROUPS}/${groupCode}`;

        request({
            url: `${baseURI}/${ResourceName.CAMPAIGNS}/${item?.id}/stop`,
        })
            .unwrap()
            .then(() => {
                notifyOk();
                onReload?.();
            })
            .catch(() => {
                // error handled in rtkQueryErrorLogger
            });
    };

    return (
        <GenericConfirmationSecondaryButton
            isDisabled={isDisabled || !(items?.length === 1 && item?.state === "WAITING")}
            onClickCallback={() => callBackend()}
            item={item || {}}
            modalTitle="list.modal.stopCampaign"
            modalBody="list.stop.confirm"
            params={{ name: item?.name }}
            translationKey="list.stop"
            onClickEventName={ButtonEvents.ADD}
            name="stop_button"
            className="aevi-button aevi-button-secondary"
        />
    );
};
